import type { Dayjs } from 'dayjs'
import de from 'dayjs/locale/de'

interface ICustomLocale extends Omit<ILocale, 'monthsShort'> {
  monthsShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
}

const locale: ICustomLocale = {
  ...de,
  name: 'de',
  weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
  weekStart: 1,
  weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
  monthsShort: (dayjsInstance: Dayjs, format: string): string => {
    const standard = 'Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sep_Okt_Nov_Dez'.split('_')
    const extended = 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.month()]
    } else {
      return standard[dayjsInstance.month()]
    }
  },
  weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
  ordinal: (n) => n
}

export default locale
